export type PermitApplicationComment = {
  id: number;
  permit_application_id: number;
  user_id: number;
  parent_id: number | null;
  author_name: string;
  body: string;
  created_at: string;
};

const jsonHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

function csrfToken(): string {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") ?? "";
}

export async function listPermitApplicationComments(
  municipalityId: number,
  applicationId: number,
): Promise<PermitApplicationComment[]> {
  const response = await fetch(
    `/api/v1/municipalities/${municipalityId}/permit_applications/${applicationId}/comments`,
    { credentials: "include", headers: { Accept: "application/json" } },
  );
  if (!response.ok) throw new Error("Failed to load comments");
  return response.json();
}

export async function createPermitApplicationComment(
  municipalityId: number,
  applicationId: number,
  body: string,
  parentId?: number,
): Promise<PermitApplicationComment> {
  const response = await fetch(
    `/api/v1/municipalities/${municipalityId}/permit_applications/${applicationId}/comments`,
    {
      method: "POST",
      credentials: "include",
      headers: { ...jsonHeaders, "X-CSRF-Token": csrfToken() },
      body: JSON.stringify({
        permit_application_comment: { body, parent_id: parentId ?? null },
      }),
    },
  );
  if (!response.ok) throw new Error("Failed to create comment");
  return response.json();
}
